import {FaAlignLeft} from "react-icons/fa6";

import {RequestsWaterfall} from "@/components/transaction/RequestsWaterfall.tsx";
import {TxnNetworkResult} from "@/lib/types/transaction.ts";

interface WaterfallIconProps {
  step: number;
  requests: TxnNetworkResult[];
}

export const StepRequestsWaterfall = ({requests, step}: WaterfallIconProps) => {
  if (requests.length < 1) return null;

  const id = `step-waterfall-${step}`;
  return (
    <>
      <button
        className="details fw-light btn btn-sm btn-link float-end text-decoration-none p-0 me-2"
        title={`Show Requests Waterfall: Step ${step}`}
        onClick={() => {}}
        data-bs-toggle="collapse"
        data-bs-target={`#${id}`}
        type="button"
        aria-expanded="false"
        aria-controls={id}
      >
        <FaAlignLeft />
      </button>
      <div className="collapse" id={id}>
        <div className="details-panel card card-body-slim bg-light-2 m-2 p-2">
          <RequestsWaterfall requests={requests} />
        </div>
      </div>
    </>
  );
};
